/* eslint-disable @typescript-eslint/no-var-requires */
export const phoenixLegalCountriesQuery = require('./lib/phoenixLegalCountriesQuery.graphql');
export const phoenixLegalMemberDetailsQuery = require('./lib/phoenixLegalMemberDetailsQuery.graphql');
export const phoenixLegalHotelSuggestionQuery = require('./lib/phoenixLegalHotelSuggestionQuery.graphql');
export const phoenixLegalVisitHotelWebsiteQuery = require('./lib/phoenixLegalVisitHotelWebsiteQuery.graphql');
export const phoenixLegalContactUsTopicsAndSubTopicsQuery = require('./lib/phoenixLegalContactUsTopicsAndSubTopicsQuery.graphql');
